export default {
  title: "Profile",
  description: "Manage your personal profile",
  personalInfo: "Personal Information",
  weddingInfo: "Wedding Information",
  form: {
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone",
    weddingDate: "Wedding Date",
    partnerName: "Partner Name",
    venue: "Venue",
    location: "Location",
    about: "About",
    save: "Save changes"
  },
  actions: {
    save: "Save",
    cancel: "Cancel",
    edit: "Edit"
  },
  messages: {
    profileUpdated: "Profile updated successfully",
    error: "An error occurred",
    updateSuccess: "Profile updated successfully",
    updateError: "Error updating profile",
    photoUploadSuccess: "Photo uploaded successfully",
    photoUploadError: "Error uploading photo"
  },
  photo: {
    alt: "Profile photo",
    upload: "Upload a photo",
    change: "Change photo",
    remove: "Delete photo"
  }
};
